import React, { useEffect, useState } from "react";
import { ReportesService } from "./integracion";
import { TrendChart } from "./partes/graficas/TrendChart";
import './Reportes.scss'

const Reportes = () => {
    const [getIncidentesPorMes, setIncidentesPorMes] = useState([]);
    const [getTendenciasIncidentes, setTendenciasIncidentes] = useState([]);
    const [getTendenciasBitacoras, setTendenciasBitacoras] = useState([]);
    const [getBitacoraEFallas, setBitacoraEFallas] = useState([]);
    const [getFallasSemana, setFallasSemana] = useState([]);
    const [getTaxisPorSemana, setTaxisPorSemana] = useState([]);
    const [getTendenciasVisitasSemana, setTendenciasVisitasSemana] = useState([]);
    const [getTendenciasSensibilidadSemana, setTendenciasSensibilidadSemana] = useState([]);
    useEffect(() => {
        if (ReportesService) {
            ReportesService.getIncidentesPorMes(setIncidentesPorMes);
            ReportesService.getTendenciasIncidentes(setTendenciasIncidentes);
            ReportesService.getTendenciasBitacoras(setTendenciasBitacoras);
            ReportesService.getPorcentajeBitacorasYFallas(setBitacoraEFallas);
            ReportesService.getFallasSemana(setFallasSemana);
            ReportesService.getTaxisPorSemana(setTaxisPorSemana);
            ReportesService.getTendenciasVisitasSemana(setTendenciasVisitasSemana);
            ReportesService.getTendenciasSensibilidadSemana(setTendenciasSensibilidadSemana);
        }
    }, [])

    return (
        <div className="Reportes">
            <TrendChart
                data={getIncidentesPorMes}
                title="Tendencia de Incidentes 12 Meses"
                dataKey="TOTAL"
                xKeyAno="ANO"
                xKeyMes="MES"
                columns={[
                    { field: "ANO", header: "Año" },
                    { field: "MES", header: "Mes" },
                    { field: "TOTAL", header: "Total" },
                ]}
                excelFileName="IncidentesPorMes"
            />

            <TrendChart
                data={getTendenciasVisitasSemana}
                title="Visitas Semanales"
                dataKey="TOTAL"
                xKeyAno="ANO"
                xKeyMes="SEMANA"
                columns={[
                    { field: "ANO", header: "Año" },
                    { field: "SEMANA", header: "Semana" },
                    { field: "TOTAL", header: "Total" },
                ]}
                excelFileName="VisitasSemana"
            />
             <TrendChart
                data={getTendenciasSensibilidadSemana}
                title="Sensación por semana"
                dataKey="TOTAL"
                xKeyAno="ANO"
                xKeyMes="SEMANA"
                columns={[
                    { field: "ANO", header: "Año" },
                    { field: "SEMANA", header: "Semana" },
                    { field: "TOTAL", header: "Total" },
                ]}
                excelFileName="SensibilidadSemana"
            />
            <TrendChart
                data={getTendenciasIncidentes}
                title="Tendencia de Incidentes 12 Semanas"
                dataKey="TOTAL"
                xKeyAno="ANO"
                xKeyMes="SEMANA"
                columns={[
                    { field: "ANO", header: "Año" },
                    { field: "SEMANA", header: "Semana" },
                    { field: "TOTAL", header: "Total" },
                ]}
                excelFileName="TendenciaIncidentes"
            />
            <TrendChart
                data={getTendenciasBitacoras}
                title="Tendencia de Bitácoras"
                dataKey="TOTAL"
                xKeyAno="ANO"
                xKeyMes="SEMANA"
                columns={[
                    { field: "ANO", header: "Año" },
                    { field: "SEMANA", header: "Semana" },
                    { field: "TOTAL", header: "Total" },
                ]}
                excelFileName="TendenciaBitacoras"
            />
              <TrendChart
                data={getFallasSemana}
                title="Tendencia Fallas 12 Semanas"
                dataKey="TOTAL"
                xKeyAno="ANO"
                xKeyMes="SEMANA"
                columns={[
                    { field: "ANO", header: "Año" },
                    { field: "SEMANA", header: "Semana" },
                    { field: "TOTAL", header: "Total" },
                ]}
                excelFileName="FallasSemana"
            />
            <TrendChart
                data={getBitacoraEFallas}
                title="Porcentaje de Bitácoras y Fallas"
                dataKey="PORCENTAJE"
                xKeyAno="ANO"
                xKeyMes="SEMANA"
                columns={[
                    { field: "ANO", header: "Año" },
                    { field: "SEMANA", header: "Semana" },
                    { field: "PORCENTAJE", header: "Porcentaje" },
                ]}
                excelFileName="PorcentajeBitacorasEIncidencias"
            />
          
            <TrendChart
                data={getTaxisPorSemana}
                // imprimirCada={2}
                title="Tendencia Taxis 12 Semanas"
                dataKey="TOTAL"
                xKeyAno="ANO"
                xKeyMes="SEMANA"
                columns={[
                    { field: "ANO", header: "Año" },
                    { field: "SEMANA", header: "Semana" },
                    { field: "TOTAL", header: "Total" },
                ]}
                excelFileName="TaxisSemana"
            />
            
           
        </div>
    )
}


export default Reportes;